import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFoundPage from '../common/NotFoundPage';
import Login from "../screen/auth/Login";
import Configmeta from "../screen/config/Configmeta";
import Editconfigmeta from "../screen/config/Editconfigmeta";
import Categories from "../screen/coupon/category/Categories";
import CouponList from "../screen/coupon/CouponList";
import Createcouponcard from "../screen/coupon/Createcouponcard";
import EditCouponList from "../screen/coupon/EditCouponList";
import Upload from "../screen/coupon/Upload";
import GetAllcoupon from "../screen/Getallcoupon";
import Home from "../screen/home/Home";
import EditKaList from "../screen/khiladiadda/Editkacoupon";
import KaCouponList from "../screen/khiladiadda/Ka_coupon";
import KaOrder from "../screen/khiladiadda/Ka_order";
import Order from "../screen/Order";
import TopupxOrders from "../screen/TopupxOrders";
import QsEdit from "../screen/qwickcilver/Editqacoupon";
import QsCouponList from "../screen/qwickcilver/Qs_coupon";
import QsOrder from "../screen/qwickcilver/Qs_order";
import PublihserList from '../screen/vouhcers/PublihserList';
import BankDetails from '../screen/vouhcers/BankDetails';
import ProtectedRoute from './ProtectedRoute';
import DetailCoupon from '../screen/coupon/DetailCoupon';
import History from '../screen/history'
import HistoryDetail from '../screen/coupon/HistoryDetail';
import Linksku from '../screen/qwickcilver/Linksku';
import PublisherCategory from '../screen/vouhcers/PublisherCategory';
import PublisherCategoryVoucherDetail from '../screen/qwickcilver/PublisherCategoryVoucherDetail';
import DiscountList from '../screen/discount/DiscountList';
import DiscountForm from '../screen/discount/DiscountForm';
import BulkDiscount from '../screen/discount/BulkDiscount';

export default function Index() {
    return (
        <>

            <BrowserRouter>
                <Routes>

                    <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                    <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
                    <Route path="/configmeta" element={<ProtectedRoute><Configmeta /></ProtectedRoute>} />
                    <Route path="/editconfigmeta" element={<ProtectedRoute><Editconfigmeta /></ProtectedRoute>} />
                    <Route path="/couponlist" element={<ProtectedRoute><CouponList /></ProtectedRoute>} />
                    <Route path="/editcouponlist" element={<ProtectedRoute><EditCouponList /></ProtectedRoute>} />
                    <Route path="/order" element={<ProtectedRoute><Order /></ProtectedRoute>} />
                    <Route path="/topupx-orders" element={<ProtectedRoute><TopupxOrders /></ProtectedRoute>} />
                    <Route path="/kacouponlist" element={<ProtectedRoute><KaCouponList /></ProtectedRoute>} />
                    <Route path="/editkalist" element={<ProtectedRoute><EditKaList /></ProtectedRoute>} />
                    <Route path="/qscouponlist" element={<ProtectedRoute><QsCouponList /></ProtectedRoute>} />
                    <Route path="/kaorder" element={<ProtectedRoute><KaOrder /></ProtectedRoute>} />
                    <Route path="/qsorder" element={<ProtectedRoute><QsOrder /></ProtectedRoute>} />
                    <Route path="/getallcoupon" element={<ProtectedRoute><GetAllcoupon /></ProtectedRoute>} />
                    <Route path="/createcouponcard" element={<ProtectedRoute><Createcouponcard /></ProtectedRoute>} />
                    <Route path="/editqslist" element={<ProtectedRoute><QsEdit /></ProtectedRoute>} />
                    <Route path="/categoires" element={<ProtectedRoute><Categories /></ProtectedRoute>} />
                    <Route path="/voucherPublishers" element={<ProtectedRoute><PublihserList /></ProtectedRoute>} />
                    <Route path="/bankDetails" element={<ProtectedRoute><BankDetails /></ProtectedRoute>} />
                    <Route path="/detailCoupon" element={<ProtectedRoute><DetailCoupon /></ProtectedRoute>} />
                    <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
                    <Route path="/history-detail" element={<ProtectedRoute><HistoryDetail /></ProtectedRoute>} />
                    <Route path="/linksku" element={<ProtectedRoute><Linksku /></ProtectedRoute>} />
                    <Route path="/qscoupon-publisher-links" element={<ProtectedRoute><PublisherCategoryVoucherDetail /></ProtectedRoute>} />
                    <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                    <Route path='/pullisher_category/:publisherId' element={<ProtectedRoute><PublisherCategory /></ProtectedRoute>}/>
                    <Route path="/discounts" element={<ProtectedRoute><DiscountList /></ProtectedRoute>} />
                    <Route path="/discounts/new" element={<ProtectedRoute><DiscountForm /></ProtectedRoute>} />
                    <Route path="/discounts/bulk" element={<ProtectedRoute><BulkDiscount /></ProtectedRoute>} />
                    <Route path="/discounts/:id/edit" element={<ProtectedRoute><DiscountForm /></ProtectedRoute>} />
                    <Route path="/login" element={<Login />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </BrowserRouter>

        </>
    )
}
